import { isEmpty } from "lodash-es";

const emailReg = /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/;

export const isEmail = (val) => {
  return isEmpty(val) || emailReg.test(val)
}
